<button
  ngfSelect
  [(file)]="selectedFile"
  (fileChange)="uploadFile()"
  (click)="resetFilePath($event)"
  [disabled]="disabled"
  class="btn btn-light"
  data-automation-id="gc-email-footer-expanded-reply-mode-attachments-button"
>
  <span>{{ 'genesysEmailAttachmentButton.attachments' | translate }}</span>
</button>
